import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

const constantRouterMap = [
  {
    path: "",
    redirect: "/workbench/index",
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/home"),
  },
  {
    path: "/login",
    component: () => import("@/views/login/index"),
  },
  { path: "/404", component: () => import("@/views/404") },
  {
    path: "/workbench",
    component: Layout,
    name: "workbench",
    meta: { title: "工作台" },
    children: [
      {
        path: "index",
        name: "workbench-index",
        component: () => import("@/views/newui/workbench/index"),
        meta: { title: "工作台" },
      },
    ],
  },
  {
    path: "/storeManage",
    component: Layout,
    name: "storeManage",
    redirect: "/storeManage/store-index",
    children: [
      {
        path: "store-index",
        name: "store-index",
        component: () => import("@/views/newui/storeManage/index"),
        meta: { title: "店铺管理" },
      },
    ],
  },
  {
    path: "/workorder",
    component: Layout,
    name: "workorder",
    redirect: "/workorder/workorder-index",
    children: [
      {
        path: "workorder-index",
        name: "workorder-index",
        component: () => import("@/views/newui/workorder/index"),
        meta: { title: "工单管理" },
      },
    ],
  },
  {
    path: "/plaza",
    component: Layout,
    name: "plaza",
    redirect: "/plaza/plaza-index",
    children: [
      {
        path: "plaza-index",
        name: "plaza-index",
        component: () => import("@/views/newui/plaza/index"),
        meta: { title: "选品广场" },
      },
      {
        path: "plaza-detail",
        name: "plaza-detail",
        component: () => import("@/views/newui/plaza/detail"),
        meta: { title: "产品详情" },
      },
    ],
  },
  {
    path: "/gallery",
    component: Layout,
    name: "gallery",
    redirect: "/gallery/gallery-index",
    children: [
      {
        path: "gallery-index",
        name: "gallery-index",
        component: () => import("@/views/newui/gallery/index"),
        meta: { title: "图库" },
      },
    ],
  },
  {
    path: "/aitools",
    name: "aitools",
    component: Layout,
    redirect: "/aitools/tool-index",
    meta: { title: "AI小工具" },
    children: [
      {
        path: "tool-index",
        name: "tool-index",
        component: () => import("@/views/newui/aitools/index"),
        meta: { title: "AI小工具" },
      },
    ],
  },
  {
    path: "/design",
    component: Layout,
    name: "design",
    redirect: "/design/design-index",
    children: [
      {
        path: "design-index",
        name: "design-index",
        component: () => import("@/views/newui/design/index"),
        meta: { title: "设计创作" },
      },
      {
        path: "agreement",
        name: "design-agreement",
        component: () => import("@/views/design/Agreement"),
        meta: { title: "支付协议" },
      },
    ],
  },
  {
    path: "/plat",
    component: Layout,
    name: "plat",
    redirect: "/plat/plat-index",
    children: [
      {
        path: "imgOutput",
        component: () => import("@/views/newui/imgOutput/index"),
        name: "img-output",
        meta: { title: "商品汇出" },
      },
      {
        path: "plat-index",
        name: "plat-index",
        component: () => import("@/views/newui/plat/index"),
        meta: { title: "运营中心" },
      },
      {
        path: "ai-prompt",
        name: "ai-prompt",
        component: () => import("@/views/plat/ai-prompt/index"),
        meta: { title: "AI提示词" },
      },
      {
        path: "ai-derivation",
        name: "ai-derivation",
        component: () => import("@/views/plat/ai-derivation/index"),
        meta: { title: "爆款图衍生" },
      },
      {
        path: "ai-title",
        name: "ai-title",
        component: () => import("@/views/plat/ai-title/index"),
        meta: { title: "AI标题" },
      },
      {
        path: "ai-zoom",
        name: "ai-zoom",
        component: () => import("@/views/plat/ai-zoom/index"),
        meta: { title: "高清放大" },
      },
      {
        path: "ai-fission",
        name: "ai-fission",
        component: () => import("@/views/plat/ai-fission/index"),
        meta: { title: "图片裂变" },
      },
      {
        path: "pod-template",
        name: "WorkflowTemplate",
        component: () => import("@/views/newui/plat/pod/template"),
        meta: { title: "工作流模板管理" },
      },
      {
        path: "templateManage/index",
        name: "templateManage",
        component: () => import("@/views/newui/plat/templateManage/index"),
        meta: { title: "模板管理" },
      },
      {
        path: "templateManage/index2",
        name: "templateManage2",
        component: () => import("@/views/plat/operation/temu/components/ProductTemplate"),
        meta: { title: "模板管理2" },
      },
      {
        path: "pod-detail",
        name: "WorkflowDetail",
        component: () => import("@/views/plat/pod/detail"),
        meta: { title: "工作流详情" },
      },
      {
        path: "editor-single",
        name: "editor-single",
        component: () => import("@/views/plat/editor/single/index"),
        meta: { title: "单图编辑" },
      },
      {
        path: "editor-multi",
        name: "editor-multi",
        component: () => import("@/views/plat/editor/multi/index"),
        meta: { title: "多图编辑" },
      },
    ],
  },
  {
    path: "/setting",
    component: Layout,
    name: "setting",
    redirect: "/setting/setting-index",
    children: [
      {
        path: "setting-index",
        name: "setting-index",
        component: () => import("@/views/setting/index"),
        meta: { title: "设置" },
      },
    ],
  },

  {
    path: "/product",
    component: Layout,
    name: "product",
    redirect: "/product/product-index",
    children: [
      {
        path: "product-index",
        name: "product-index",
        component: () => import("@/views/newui/product/index"),
        meta: { title: "产品管理" },
      },
    ],
  },
  {
    path: "/goods",
    component: Layout,
    name: "goods",
    redirect: "/goods/goods-index",
    children: [
      {
        path: "goods-index",
        name: "goods-index",
        component: () => import("@/views/newui/goods/index"),
        meta: { title: "商品列表" },
      },
      {
        path: "goods-detail",
        name: "goods-detail",
        component: () => import("@/views/newui/goods/detail"),
        meta: { title: "商品详情" },
      },
    ],
  },
  {
    path: "/order",
    component: Layout,
    name: "order",
    redirect: "/order/order-index",
    children: [
      {
        path: "order-index",
        name: "order-index",
        component: () => import("@/views/newui/order/index"),
        meta: { title: "订单管理" },
      },
    ],
  },
  {
    path: "/mockupManage",
    component: Layout,
    name: "mockupManage",
    redirect: "/mockupManage/demoManage",
    children: [
      {
        path: "demoManage",
        name: "demoManage",
        component: () => import("@/views/newui/demoManage/index"),
        meta: { title: "样机管理" },
      },
    ],
  },

  {
    path: "/asset",
    component: Layout,
    name: "asset",
    redirect: "/asset/asset-index",
    children: [
      {
        path: "asset-index",
        name: "asset-index",
        component: () => import("@/views/newui/asset/index"),
        meta: { title: "资产管理" },
      },
    ],
  },
  {
    path: "/employee",
    component: Layout,
    name: "employee",
    redirect: "/employee/employee-index",
    children: [
      {
        path: "employee-index",
        name: "employee-index",
        component: () => import("@/views/newui/employee/index"),
        meta: { title: "员工管理" },
      },
    ],
  },
  {
    path: "/change-password",
    component: Layout,
    name: "change-password",
    redirect: "/change-password/changePassword-index",
    children: [
      {
        path: "changePassword-index",
        name: "changePassword-index",
        component: () => import("@/views/newui/changePassword/index"),
        meta: { title: "修改密码" },
      },
    ],
  },
  {
    path: "/quick-start",
    component: Layout,
    name: "quick-start",
    redirect: "/quick-start/quickStart-index",
    children: [
      {
        path: "quickStart-index",
        name: "quickStart-index",
        component: () => import("@/views/setting/index"),
        meta: { title: "快速入门" },
      },
    ],
  }
];

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
});
